import { AnaliseNfe } from '@core/models/entities/nfe-analise/analise-nfe';
import { UsuarioCreditos } from '@core/models/responses/usuario/usuario-response';
import { AuthService } from '@core/services/auth/auth.service';
import { NfeService } from '@core/services/nfe/nfe.service';
import { UsuarioService } from '@core/services/usuario/usuario.service';
import { CONFEAR_PERMISSIONS } from 'src/app/core/consts/CONFEAR-PERMISSIONS';
import { ModalService } from 'src/app/core/services/modal/modal.service';

import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { Subscription, lastValueFrom } from 'rxjs';

import { NfeAnaliseComponent } from '../../../../pages/nfe/analise/nfe-analise.component';
import { LoadingFragmentComponent } from '../../loading-fragment/loading-fragment.component';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-modal-nfe-analise',
  template: `
    <app-modal [width]="'90vw'" [modalFull]="modalFull" (closeModal)="close()" [display]="open">
      <section header>Analisar NF-e</section>
      <app-loading-fragment [loading]="loading"></app-loading-fragment>
      <ng-container *ngIf="!messageError && !mensagemSemCreditos">
        <app-nfe-analise
          [analiseNfeResponse]="analiseNfeResponse"
          [creditos]="creditos"
          [nfe]="nfe"></app-nfe-analise>
      </ng-container>

      <ng-container *ngIf="messageError">
        {{ messageError }}
      </ng-container>

      <ng-container *ngIf="mensagemSemCreditos">
        <section class="container-sem-credito">
          <span class="material-icons icon">error</span>
          <div
            class="content-sem-credito"
            [innerHTML]="mensagemSemCreditos"></div>
        </section>
      </ng-container>
    </app-modal>
  `,
  imports: [
    CommonModule,
    ModalComponent,
    NfeAnaliseComponent,
    LoadingFragmentComponent
  ],
  styleUrls: ['./modal-nfe-analise.component.scss']
})
export class ModalNfeAnaliseComponent implements OnInit, OnDestroy {
  open: boolean;
  loading: boolean;
  nfe: any;
  subscription: Subscription[] = [];
  messageError: string;
  creditos: UsuarioCreditos;
  mensagemSemCreditos: string;
  analiseNfeResponse: AnaliseNfe;
  private authService = inject(AuthService);
  private usuarioService = inject(UsuarioService);
  private modalService = inject(ModalService);
  private nfeService = inject(NfeService);
  modalFull: boolean;

  ngOnInit(): void {
    this.listenModal();
  }

  async listenModal() {
    const subscription = this.modalService.listenChanges().subscribe(res => {
      if (res.id === CONFEAR_PERMISSIONS.ANALISAR_NFE && res.open) {
        this.handleAnaliseNfeModal(res.data);
      }
    });

    this.subscription.push(subscription);
  }

  async handleAnaliseNfeModal(data: any) {
    this.nfe = data;
    this.loading = true;

    if (this.authService.isMasterAcode) {
      await this.verificaCreditos();
    }

    if (!this.mensagemSemCreditos) {
      await this.getNfe();
    }

    this.loading = false;
    this.open = true;
    this.modalFull = true;
  }

  async verificaCreditos() {
    const response = await lastValueFrom(
      this.usuarioService.getCreditos(String(CONFEAR_PERMISSIONS.ANALISAR_NFE))
    );
    this.creditos = response?.dados?.creditos;
    this.mensagemSemCreditos = response?.mensagem;
  }

  async getNfe() {
    const chave = this.nfe?.chaveNfe ? this.nfe?.chaveNfe : this.nfe?.chave;

    const response = await lastValueFrom(this.nfeService.nfeAnalysis(chave));
    const { dados, error } = response;

    if (dados) {
      this.analiseNfeResponse = dados;
    }

    if (error?.mensagem) {
      this.messageError = error?.mensagem.reduce((acc, cc) => {
        this.messageError.concat(cc);
      });
    }
  }

  close() {
    this.loading = false;
    this.open = false;
    this.messageError = '';
    this.modalFull = false;
  }

  ngOnDestroy() {
    this.subscription.forEach(sub => sub.unsubscribe());
  }
}
